// src/components/dashboard/StatCards.jsx
import { C } from '../../styles/tokens';

const STATS = [
  { icon: '📄', label: 'Applications', value: '12',   sub: '3 active',        color: C.magenta, delta: '+2 this week'   },
  { icon: '🎯', label: 'Match Score',  value: '87%',  sub: 'Top 15%',         color: C.violet,  delta: '+5% this month' },
  { icon: '🪙', label: 'ONT Balance',  value: '1,240',sub: '≈ $186 USDT',     color: C.warning, delta: '+120 this week'  },
  { icon: '🏅', label: 'Certificates', value: '4',    sub: '2 in progress',   color: C.success, delta: 'Next: React Adv' },
];

export default function StatCards() {
  return (
    <>
      <style>{`
        .stat-cards-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 14px;
        }
        @media (max-width: 768px) {
          .stat-cards-grid { grid-template-columns: repeat(2, 1fr) !important; }
        }
        @media (max-width: 400px) {
          .stat-cards-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
      <div className="stat-cards-grid">
        {STATS.map((s, i) => (
          <div
            key={i}
            className="card"
            style={{ padding: '20px', transition: 'all .25s' }}
            onMouseEnter={e => { e.currentTarget.style.transform='translateY(-3px)'; e.currentTarget.style.borderColor=`rgba(254,52,232,.25)`; e.currentTarget.style.boxShadow='0 14px 40px rgba(95,8,231,.2)'; }}
            onMouseLeave={e => { e.currentTarget.style.transform='translateY(0)'; e.currentTarget.style.borderColor='rgba(254,52,232,.1)'; e.currentTarget.style.boxShadow='none'; }}
          >
            <div style={{ position:'absolute', top:0, left:0, right:0, height:'2px', background:`linear-gradient(90deg,${s.color}70,transparent)` }} />
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:'12px' }}>
              <div style={{ width:'40px', height:'40px', borderRadius:'10px', background:`${s.color}15`, display:'flex', alignItems:'center', justifyContent:'center', fontSize:'19px' }}>{s.icon}</div>
              <span style={{ fontSize:'10px', color:s.color, background:`${s.color}12`, padding:'2px 7px', borderRadius:'100px', fontWeight:600, textAlign:'right', maxWidth:90, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{s.delta}</span>
            </div>
            <div className="syne" style={{ fontSize:'clamp(20px,3vw,26px)', fontWeight:800, color:s.color, lineHeight:1 }}>{s.value}</div>
            <div style={{ fontSize:'12px', color:'rgba(255,255,255,.65)', fontWeight:600, marginTop:'3px' }}>{s.label}</div>
            <div style={{ fontSize:'11px', color:'rgba(255,255,255,.28)', marginTop:'2px' }}>{s.sub}</div>
          </div>
        ))}
      </div>
    </>
  );
}
